import { useContext } from "react";
import AuthContext from '../context/Autherization/auth-context';
export default function useAuth(){
    return useContext(AuthContext);
}